import { render, staticRenderFns } from "./NoteAssessment.vue?vue&type=template&id=335b7a7d"
import script from "./NoteAssessment.vue?vue&type=script&lang=js"
export * from "./NoteAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports